// system setings states
import i18n from '@/i18n'

export default {
  systemSettings: {},
  cashierLoginOptions: [{ text: i18n.t('Name'), value: 'Name' }, { text: i18n.t('Code'), value: 'Code' }],
  systemCurrencyOptions: [{ text: i18n.t('USD'), value: 'USD' }, { text: i18n.t('IQD'), value: 'IQD' }],
  accountingOptions: [
    { text: i18n.t('Together'), value: 'Together' },
    { text: i18n.t('Separated'), value: 'Separated' }
  ],
  activeInactiveOptions: [{ text: i18n.t('Active'), value: 'Active' }, { text: i18n.t('Inactive'), value: 'Inactive' }]
}
